<Dialog bind:value={showDialog} class="w-full md:w-1/2" {transitionProps}>
    <div slot="title" class="text-lg font-normal">{ $confirmDialog.title }</div>
    <div>
        { $confirmDialog.message }
    </div>
    <div slot="actions">
        <Button color="secondary" on:click={rejectAction}>Tühista</Button>
        <Button on:click={confirmAction}>Kinnita</Button>
    </div>
</Dialog>

<script lang="ts">
  import {Dialog, Button} from 'smelte';
  import {confirmDialog} from '../../../stores';
  import {quadIn} from 'svelte/easing';

  export let showDialog: boolean = false;

  const transitionProps = {duration: 150, easing: quadIn, delay: 0};

  function confirmAction() {
    $confirmDialog.confirmAction(true);
    confirmDialog.hide();
  }

  function rejectAction() {
    confirmDialog.hide();
  }
</script>